import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import findIndex from 'lodash/findIndex';

import theme from './Tabs.scss';

const Tabs = ({ list, selectedKey, onSelect, disabled, rtl }) => {
  const tabWidth = 100 / list.length;
  const multiplier = rtl ? -100 : 100;
  const selectedTabIndex = findIndex(list, ({ key }) => key === selectedKey);

  return (
    <div className={ theme.root } role="menu">
      <div className={ theme.headingContainer }>
        {
          list.map(
            ({ ariaLabel, heading, key, testId }) => (
              <button
                role="tab"
                aria-label={ ariaLabel }
                aria-selected={ selectedKey === key }
                data-testid={ testId }
                disabled={ disabled }
                onClick={ () => onSelect(key) }
                className={ classnames(theme.heading, {
                  [theme.selected]: selectedKey === key,
                }) }
                key={ key }
              >
                { heading }
              </button>
            ),
          )
        }
        <div
          className={ theme.underline }
          style={{
            width: `${ tabWidth }%`,
            transform: `translateX(${ multiplier * selectedTabIndex }%)`,
          }}
        />
      </div>
      <div className={ theme.contentContainer }>
        <div
          className={ theme.tabsContentScroller }
          style={{
            transform: `translateX(${ -1 * multiplier * selectedTabIndex }%)`,
          }}
        >
          { list.map(({ content, key }) => (
            <div key={ `tab-${ key }` } className={ theme.tabContentContainer }>
              { content }
            </div>
          )) }
        </div>
      </div>
    </div>
  );
};

Tabs.propTypes = {
  disabled: PropTypes.bool,
  /** selectedKey key of currently selected tab */
  selectedKey: PropTypes.string.isRequired,
  /** onSelect will be executed if tab selected and parse key of selected tab */
  onSelect: PropTypes.func.isRequired,
  /** list tabs that need to be */
  list: PropTypes.arrayOf(PropTypes.shape({
    /** key identifier of current tab */
    key: PropTypes.string.isRequired,
    /** heading component that will rendered in tab heading */
    heading: PropTypes.node.isRequired,
    /** content that will be rendered if current tab will be selected */
    content: PropTypes.node.isRequired,
  })).isRequired,
};

Tabs.defaultProps = {
  disabled: false,
};

export default Tabs;
